import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";
import Seo from "../../components/Seo";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-4">
      <Seo title="Admin Login — Razor Build" description="Razor Build admin area." />
      <div data-testid="admin-login-card" className="w-full max-w-sm bg-white p-8 border border-line">
        <img src="/logo-full-black.png" alt="Razor Build" className="h-12 w-auto mx-auto mb-6" />
        <h1 className="font-display font-bold text-xl text-ink text-center">Admin Dashboard</h1>
        <p className="text-xs text-slate2 text-center mt-1 mb-7">Razor Build Limited — authorised access only</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label htmlFor="admin-email" className="block font-mono text-[10px] tracking-[0.18em] uppercase text-slate2 mb-1.5">Email</label>
            <input id="admin-email" data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" className="w-full border border-line px-4 py-3 text-sm focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold" />
          </div>
          <div>
            <label htmlFor="admin-password" className="block font-mono text-[10px] tracking-[0.18em] uppercase text-slate2 mb-1.5">Password</label>
            <input id="admin-password" data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" className="w-full border border-line px-4 py-3 text-sm focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-xs text-red-600 bg-red-50 border border-red-200 px-3 py-2.5">{error}</p>}
          <button type="submit" disabled={busy} data-testid="admin-login-submit" className="w-full inline-flex items-center justify-center gap-2 bg-ink text-white font-mono text-[11px] tracking-[0.2em] uppercase px-4 py-3.5 hover:bg-charcoal disabled:opacity-60 transition-colors">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-3.5 h-3.5 text-gold" />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
